var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"container",class:['video-container']},[_c('div',{staticClass:"canvasSection"},[_c('div',{staticClass:"slotContent"},[_vm._t("default")],2),_c('canvas',{ref:"canvas"})])])}
var staticRenderFns = []

export { render, staticRenderFns }